<template>

<main class="py-12 space-y-12">
        <SectionsSectionIntro
            :images="sectionIntro.images"
            :title="sectionIntro.title"
            :teaser="sectionIntro.teaser"
            :text="sectionIntro.text"
        />


        <section>
            <div class="container grid lg:grid-cols-2 gap-12">
                <UCard class="card">
                    <template #header>
                        <NuxtPicture
                            src="BQ4C3431.jpg"
                            alt="Qualifizierter Spielplatzprüfer"
                            class="w-full aspect-video object-cover"
                            :img-attrs="{ class: 'rounded-lg' }"
                        />
                    </template>

                    <template #default>
                        <h3 class="column-title h3 mt-none mb-min">
                            Garantieleistung
                        </h3>
                        <p class="column-teaser my-none">
                            Die Kombination aus Material und Verarbeitung machen Sauerland Spielgeräte zu einem
                            absoluten Qualitätsprodukt. Die hochwertigen Eigenschaften unserer Rohstoffe (u.a.
                            langlebig, witterungsbeständig, stabil und vieles mehr) bedeuten für Sie Sicherheit und
                            Beständigkeit.
                        </p>
                    </template>

                    <template #footer>
                        <a
                            class="button bordered flex! gap-2 justify-center items-center"
                            href="/pdf/Sicherheitsbereiche-Garantie-Stand-November-2025.pdf"
                            target="_blank"
                        >
                            <IconDownload/>
                            Sauerland Spielgeräte Garantie
                        </a>
                    </template>
                </UCard>

                <UCard class="card">
                    <template #header>
                        <NuxtPicture
                            src="BQ4C5466.jpg"
                            alt="Qualifizierter Spielplatzprüfer"
                            class="w-full aspect-video object-cover"
                            :img-attrs="{ class: 'rounded-lg' }"
                        />
                    </template>

                    <template #default>
                        <h3 class="column-title h3 mt-none mb-min">
                            Wartung
                        </h3>
                        <p class="column-teaser my-none">
                            Spielplatzgeräte müssen einer regelmäßigen, gewissenhaften Inspektion und Wartung unterzogen
                            werden (EN 1176-7). Mit dieser Wartung und Inspektion sind nur sachkundige Personen oder
                            Firmen zu beauftragen.
                        </p>
                    </template>

                    <template #footer>
                        <a
                            class="button bordered flex! gap-2 justify-center items-center"
                            href="/pdf/Wartungsanleitung.pdf"
                            target="_blank"
                        >
                            <IconDownload/>
                            Wartungsanleitung
                        </a>
                    </template>
                </UCard>
            </div>
        </section>
    </main>
</template>

<script setup lang="ts">
import IconDownload from '~/components/Icons/IconDownload.vue';

definePageMeta({
    path: '/Service/Garantie-und-Wartung',
});

const header = useState<{ title: string; subTitle: string }>(
    'header',
);
header.value = {
    title: 'Eine Welt',
    subTitle: 'voller Sicherheit',
};

const sectionIntro = {
    images: ['BQ4C6241.jpg', 'BQ4C1368-1.jpg', 'AdobeStock_140518718.jpg'],
    title: 'Sicherheit zum Schutz Ihrer Kinder',
    teaser: '',
    text: '<p>Als Spielgeräte-Hersteller produzieren wir für Kinder mit den allerhöchsten Ansprüchen. Davon sind vor Allem die Bereiche der Sicherheit und der Qualität unserer Produkte betroffen.</p>',
};
</script>

<style scoped>

</style>
